import request from "@/config/utils/request";

// 标书开启列表
export function queryApi(url, data, method) {
  return request({
    url: url,
    method: method || "post",
    timeout: 30 * 1000,
    data
  });
}

//开标准备详情查询
export function qryBidOpenDetail(data) {
  return request({
    url: "/apis/bid-scp/bidc/qryBidOpenDetail",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    data
  });
}

//审批页面及审批详情页面查询相关ID
export function queryTodomsgDetailById(data) {
  return request({
    url: "/apis/bid-scp/bidc/queryTodomsgDetailById",
    method: "post",
    data
  });
}
